import axios from "axios";

// Unauthenticated client for the citizen-facing Transparency & Accountability portal.
export const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/public` });

export const P = {
  navy: "#12263A",
  navyDeep: "#0B1826",
  gold: "#B98A1E",
  paper: "#F6F4EF",
  card: "#FFFFFF",
  ink: "#1E2A36",
  dim: "#5B6B7A",
  line: "#DDD7CA",
  red: "#B3261E",
  green: "#1E7B4F",
};
